export default __webpack_public_path__ + "static/clips-thumb-b0c2c93e43dc4ae9397015366a20fa61.gif";